import {
  IDmcTourOptionTransferRate,
  TransferTypeEnum,
} from "commonFnBcode/joiSchemas/Dmc.schemas";
import {
  IDmcTourOptionTicketRates,
  IGetTourOpitonParams,
  sharingBasisEnum,
} from "dmcMaster/rateManagement/DmcRates.types";
import { getRequest, postRequest } from "components/common/ajax";
import { IDMCTourOption, TDMCCombo } from "commonFnBcode/types/dmc.types";
import moment from "moment";

export class DmcMasterApi {
  async createNewMarket(props: { name: string }) {
    const response = await postRequest("dmc/createNewMarket", props);
    return response;
  }

  async searchMarket(props: { name: string }) {
    const response = await getRequest("dmc/searchMarket", props);
    return response;
  }

  async getDefaultMarketOptions() {
    const response = await getRequest("dmc/getDefaultMarketOptions");
    return response;
  }

  async updateMarketOfCustomer(props: {
    customerId: number;
    marketId: number;
  }) {
    const response = await postRequest("dmc/updateMarketForCustomer", props);
    return response;
  }

  static async getTourOptionsByCity(props: { cityId: number }) {
    const response = await postRequest("dmc/getTourOptionsByCity", props);
    return response;
  }
  static async getCombos(props: { name?: string; id?: number }) {
    const response = await postRequest("dmc/getCombos", props);
    return response;
  }

  // API to create a new combo
  static async createCombo(payload: TDMCCombo) {
    const response = await postRequest("dmc/createDmcCombo", payload);
    return response;
  }

  static async getAccomodations(props: { name?: string; id?: number }) {
    const response = await getRequest("dmc/getAccomodation", props);
    return response;
  }

  static async saveNewAccomodation(props: any) {
    const response = await postRequest("dmc/createNewAccomodation", props);
    return response;
  }

  static async saveActivity(props: any) {
    const response = await postRequest("dmc/saveActivity", props);
    return response;
  }
  static async getActivities(props: any) {
    const response = await getRequest("dmc/getActivities", props);
    return response;
  }

  static async getTourOptions(props: any) {
    const response = await getRequest("dmc/getTourOptions", props);
    return response;
  }

  static async saveTourOptions(props: any) {
    const response = await postRequest("dmc/saveTourOptions", props);
    return response;
  }

  static async saveDriver(props: any) {
    const response = await postRequest("dmc/saveDriver", props);
    return response;
  }

  static async getDrivers(props: any) {
    const response = await getRequest("dmc/getDrivers", props);
    return response;
  }

  static async getLocationOptions(props: any) {
    const response = await getRequest("dmc/getLocationOptions", props);
    return response;
  }

  static async saveTransferLocation(props: any) {
    const response = await postRequest("dmc/saveLocationOption", props);
    return response;
  }

  static async saveKart(props: any) {
    const response = await postRequest("kart/saveKart", props);
    return response;
  }

  static async removeKartAccomodation(props: any) {
    const response = await postRequest("kart/removeKartAccomodation", props);
    return response;
  }
  static async removeKartActivity(props: any) {
    const response = await postRequest("kart/removeKartActivity", props);
    return response;
  }
  static async removeKartMiscellaneous(props: any) {
    const response = await postRequest("kart/removeKartMiscellaneous", props);
    return response;
  }

  static async getAllKarts(props: {
    page: number;
    fromDate: string;
    toDate: string;
    filterType: string;
    sortBy: string;
    referenceNo: string;
  }) {
    const response = await getRequest("kart/getAllKartsForWl", props);
    return response;
  }
  static async getKartById(id: number) {
    const response = await getRequest("kart/getKartById", {
      id,
    });
    return response;
  }
  static async getJobSheet(
    dateRange: { from: Date; to: Date },
    driverId?: number,
    sortBy?: string
  ) {
    const response = await postRequest("dmc/getTransferJobSheet", {
      dateRange,
      driverId,
      sortBy,
    });
    return response;
  }

  static async getDMCItinerariesByDate(dateString: string) {
    const response = await postRequest("dmc/getItinerariesByDate", {
      date: dateString,
    });
    return response;
  }

  static async getAllDmcData() {
    const response = await postRequest("dmc/getAllDmcData", {});
    return response;
  }

  static async getDriverJobSheet(
    dateRange: { from: Date; to: Date },
    driverAccessToken: string
  ) {
    const response = await postRequest("dmcDriver/getDriverTransferJobSheet", {
      dateRange,
      driverAccessToken,
    });
    return response;
  }

  static async updateTransferDriver(id: number, driverId: number) {
    const response = await postRequest("dmc/updateTransferDriver", {
      id,
      driverId,
    });
    return response;
  }

  static async updateTransferDriverCharges(id: number, charges: number) {
    const response = await postRequest("dmc/updateTransferDriverCharges", {
      id,
      charges,
    });
    return response;
  }

  static async generateDriverAccessToken(driverId: number) {
    const response = await postRequest("dmc/generateDriverAccessToken", {
      driverId,
    });
    return response;
  }

  static async updateTransferDoneByDriver(
    transferid: number,
    driverAccessToken: string
  ) {
    const response = await postRequest("dmcDriver/updateTransferDoneByDriver", {
      transferid,
      driverAccessToken,
    });
    return response;
  }
  static async updateTransferStatusByStaff(
    transferid: number,
    isCompleted: boolean
  ) {
    const response = await postRequest("dmc/updateTransferStatusByStaff", {
      transferid,
      isCompleted,
    });
    return response;
  }

  static async saveTourOptionTicketRates(props: IDmcTourOptionTicketRates) {
    const response = await postRequest("dmc/saveActivityTicketRates", props);
    return response;
  }

  static async getTourOptionTicketRates(props: {
    marketId: number;
    tourOptionId: number;
  }) {
    const response = await getRequest("dmc/getTourOptionTicketRates", props);
    return response;
  }

  static async deleteTourOptionTicketRates(props: { rateId: number }) {
    const response = await postRequest(
      "dmc/deleteTourOptionTicketRates",
      props
    );
    return response;
  }

  static async changeTourOptionTicketRatePriority(props: {
    newPriority: Array<any>;
  }) {
    let data = {
      newPriority: props.newPriority.reverse(),
    };
    const response = await postRequest(
      "dmc/changeTourOptionTicketRatePriority",
      data
    );
    return response;
  }

  static async saveTourOptionTransferRates(props: IDmcTourOptionTransferRate) {
    const response = await postRequest("dmc/saveTourOptionTransferRates", {
      ...props,
      // validFromDate: moment(props.validFromDate).format("YYYY-MM-DD"),
      // validTillDate: moment(props.validTillDate).format("YYYY-MM-DD"),
    });
    return response;
  }

  static async getTourOptionTransferRates(props: {
    marketId: number;
    tourOptionId: number;
  }) {
    const response = await getRequest("dmc/getTourOptionTransferRates", props);
    return response;
  }

  //create api for deleting tour option transfer rates
  static async deleteTourOptionTransferRates(props: { rateId: number }) {
    const response = await postRequest(
      "dmc/deleteTourOptionTransferRates",
      props
    );
    return response;
  }

  //create api for changing tour option transfer rate priority
  static async changeTourOptionTransferRatePriority(props: {
    newPriority: Array<any>;
  }) {
    let data = {
      newPriority: props.newPriority.reverse(),
    };
    const response = await postRequest(
      "dmc/changeTourOptionTransferRatePriority",
      data
    );
    return response;
  }

  static async getTourOptionPrice(props: IGetTourOpitonParams) {
    const response = await postRequest(
      "dmc/getTourOptionPriceForQuotationBuilder",
      props
    );
    return response;
  }
}
